import React from 'react';
import { formatHelper } from '../../../helpers/formatHelper';

const ApplicationNumber = ({ application }) => (
  <h2 className="h2-title mb-0 margin-top">Заявление №{formatHelper.appNumber(application)}</h2>
);

export default ApplicationNumber;
